import moment from 'moment';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';

import Data from '../../../components/Display/Data';
import '../../../components/Display/Data.scss';
import DataTag from '../../../components/Display/DataTag';
import { getConstant } from '../../../utils/constants';
import MultiLineData from '../../../components/Display/MultiLineData';
import Section from '../../../components/Display/Section';

import MultipleDataTag from '../../../components/Display/MultipleDataTag';
import ImageItem from '../common/image/ImageItem';
import styles from "../../../components/Display/Wrapper.module.scss";


function NewsDetail({ news, handleUpdateNews, handleDelete, scope }) {
  const updateNewsActions = [
    {
      onClick: handleUpdateNews,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (news) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette Actualité ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(news)
    });
  };

  return (
    <div className={styles.scrollableSectionContainer}>
      <Section label="Informations Générales" actions={updateNewsActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={news.title} large />
          <Data
            key="publication_date"
            label={'Date de publication'}
            value={moment(news.publication_date).format('LL')}
            large
          />
          <DataTag
            key="is_internal"
            label={'Interne / Externe'}
            tag={{
              label: news.source_label ? 'Externe' : 'Interne',
              bgColor: 'bg-purple-700'
            }}
            large
          />

          <DataTag
            key="type"
            label={'Type'}
            tag={{
              label: getConstant(`${scope}.availableNewsTypes`, news.type).label,
              icon: 'star',
              bgColor: 'bg-sky-950'
            }}
            large
          />
        </div>
        <div className="flex flex-wrap gap-5">
          <MultiLineData key="hat" label={'Résumé'} value={news.hat} large />
        </div>

        {!news.source_label ? (
          <>
            <MultipleDataTag key="tags" label={'Mots clés'} tags={news.tags} />
            <div className="flex flex-wrap gap-5">
              <MultiLineData key="content" label={'Contenu'} value={news.content} large asHtml />
            </div>
          </>
        ) : (
          <>
            <Data key="source_label" label={'Titre de la source'} value={news.source_label} large />
            <Data key="source_url" label={'URL de la source'} value={news.source_url} large />
          </>
        )}
      </Section>
      <Section label="Image principale">
        <ImageItem image={news.image} className="w-96" />
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'actualité"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(news)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default NewsDetail;
